import {Tr} from "@/i18n/i18n";
import {HorizontalStandardPanel} from "@/scenes.ui/horizontal-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import CU from "@/utils/c-u";
import {StringUtils} from "@/utils/string-utils";
import SkillUtils from "@/utils/skill-utils";


export class ExperienceInfoPanel extends HorizontalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, currentExp: number, maxExp: number, level: number, healthAddition:number) {
        super(scene, canvas, Tr('uroven').toUpperCase() + ' ' + level);

        let currentExpStateText = TextUtils.addTextByFamily(scene, Tr('opit') + currentExp.toString() + ' / ' + maxExp.toString(),
            0, -110, '#ffd465', 18, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let needExpText = TextUtils.addTextByFamily(scene, '(' + (maxExp - currentExp) + ' ' + Tr('exp.t.lev') + ' ' + (level + 1) + ')',
            0, currentExpStateText.y / CU.S + 50, '#f3f3f3', 16, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let infoLevelRewardText = TextUtils.addTextByFamily(scene, StringUtils.formatString(Tr('nabirayte.opit.i.poluchayte.k.zdorovju'),
                SkillUtils.formatHealth(healthAddition)),
            0, needExpText.y / CU.S + 80, '#716f6a', 16, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        this.addCloseButton(Tr('horosho'));

        this.add([currentExpStateText, needExpText, infoLevelRewardText]);

    }


}
